import { differenceInMonths, differenceInYears, parseISO } from 'date-fns';
import type { TFunction } from 'i18next';

export interface PatientAge {
  years: number;
  months: number;
}

export function computeAge(dateOfBirthIso: string | null): PatientAge | null {
  if (dateOfBirthIso === null || dateOfBirthIso.trim().length === 0) {
    return null;
  }
  const birthDate = parseISO(dateOfBirthIso);
  if (Number.isNaN(birthDate.getTime())) {
    return null;
  }
  const now = new Date();
  const totalMonths = differenceInMonths(now, birthDate);
  if (totalMonths < 0) {
    return null;
  }
  const years = differenceInYears(now, birthDate);
  const months = totalMonths - years * 12;
  return { years, months };
}

export function formatPatientAge(dateOfBirthIso: string | null, t: TFunction): string | null {
  const age = computeAge(dateOfBirthIso);
  if (age === null) {
    return null;
  }
  if (age.years === 0 && age.months === 0) {
    return t('common:unit.ageNewborn');
  }
  if (age.years === 0) {
    return t('common:unit.ageMonths', { count: age.months });
  }
  if (age.months === 0) {
    return t('common:unit.ageYears', { count: age.years });
  }
  return t('common:unit.ageYearsMonths', { years: age.years, months: age.months });
}
